import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  USER_ROLES,
  USER_STATUS,
  LEAD_SOURCE,
  FORM_SOURCE_TYPE,
  FUNNEL_TYPE_FILTER,
  LEAD_LOGS_STATUS_TYPE,
  FUNNEL_PERFORMANCE_DURATION_FILTER,
  BLOCKED_LEAD_TASK_TYPE,
  CUSTOMER_SITE_CREATION_STATUS
} from "../strings";
import { Translation } from "react-i18next";

const { WEEK, FORTNIGHT, MONTH, BT_LAST_NINETY_DAYS } =
  FUNNEL_PERFORMANCE_DURATION_FILTER;

export const dateRangeOptions = [
  {
    name: (
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <Translation>
            {(t) => t("advancedFilter.dateRange.custom")}
          </Translation>
        </div>
        <FontAwesomeIcon icon={faCalendarAlt} />
      </div>
    ),
    _id: "custom"
  },
  { name: "advancedFilter.dateRange.today", _id: "TD" },
  { name: "advancedFilter.dateRange.yesterday", _id: "YD" },
  { name: "advancedFilter.dateRange.thisWeek", _id: "TW" },
  { name: "advancedFilter.dateRange.lastWeek", _id: "LW" },
  { name: "advancedFilter.dateRange.thisMonth", _id: "TM" },
  { name: "advancedFilter.dateRange.lastMonth", _id: "LM" },
  { name: "advancedFilter.dateRange.thisYear", _id: "TY" },
  { name: "advancedFilter.dateRange.lastYear", _id: "LY" }
];

export const fbDateRangeOptions = [
  {
    name: (
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <Translation>
            {(t) => t("advancedFilter.dateRange.custom")}
          </Translation>
        </div>
        <FontAwesomeIcon icon={faCalendarAlt} />
      </div>
    ),
    _id: "custom"
  },
  { name: "advancedFilter.dateRange.yesterday", _id: "YD" },
  { name: "advancedFilter.dateRange.last7D", _id: WEEK },
  { name: "advancedFilter.dateRange.last14D", _id: FORTNIGHT },
  { name: "advancedFilter.dateRange.last30D", _id: MONTH },
  { name: "advancedFilter.dateRange.last90D", _id: BT_LAST_NINETY_DAYS },
  { name: "advancedFilter.dateRange.thisYear", _id: "BT_TY" }
];

export const funnelOverviewPerformanceDateRangeOptions = [
  { name: "advancedFilter.dateRange.last7D", _id: WEEK },
  { name: "advancedFilter.dateRange.last14D", _id: FORTNIGHT },
  { name: "advancedFilter.dateRange.last30D", _id: MONTH },
  { name: "advancedFilter.dateRange.last90D", _id: BT_LAST_NINETY_DAYS }
];

export const statusOptions = [
  { name: "Success", _id: LEAD_LOGS_STATUS_TYPE.SUCCESS },
  { name: "Fail", _id: LEAD_LOGS_STATUS_TYPE.FAIL }
  // { label: "Retry", value: LEAD_LOGS_STATUS_TYPE.RETRY },
];

export const resourceTypeOptions = [
  { name: "createFunnelModal.actions.lead", _id: FUNNEL_TYPE_FILTER.LEAD },
  {
    name: "createFunnelModal.actions.employee",
    _id: FUNNEL_TYPE_FILTER.EMPLOYEE
  }
];

export const formTypeOptions = [
  { name: "Cockpit", _id: FORM_SOURCE_TYPE.CP },
  { name: "Facebook", _id: FORM_SOURCE_TYPE.FB },
  {
    name: "Cockpit & Facebook",
    _id: FORM_SOURCE_TYPE.CP_FB
  }
];

export const sourceOptions = [
  { name: "Cockpit", _id: LEAD_SOURCE.CP },
  { name: "Facebook Cockpit", _id: LEAD_SOURCE.FB_CP },
  { name: "Facebook Ad", _id: LEAD_SOURCE.FB_AD },
  { name: "Homepage", _id: LEAD_SOURCE.HOMEPAGE },
  { name: "Uncategorised", _id: LEAD_SOURCE.UNCATEGORISED }
];

export const userStatusOptions = [
  { name: "Acitve", _id: USER_STATUS.ACTIVE },
  { name: "In-active", _id: USER_STATUS.IN_ACTIVE }
];

export const userRoleOptions = Object.entries(USER_ROLES).map((item) => ({
  _id: item[0],
  name: item[1].toLowerCase()
}));

export const fbSortOptions = [
  { name: "advancedFilter.fbSort.leadCount", _id: "leadcount" },
  { name: "advancedFilter.fbSort.costPerLead", _id: "cpl" },
  { name: "advancedFilter.fbSort.costPerQualified", _id: "cpql" },
  {
    name: "advancedFilter.fbSort.qualifiedCount",
    _id: "leadqualifiedcount"
  },
  { name: "advancedFilter.fbSort.click", _id: "clicks" },
  { name: "advancedFilter.fbSort.reach", _id: "reach" },
  { name: "advancedFilter.fbSort.impressions", _id: "impressions" },
  { name: "advancedFilter.fbSort.costPerClick", _id: "cpc" },
  { name: "advancedFilter.fbSort.spend", _id: "spend" }
];

export const insightLeadSortOptions = [
  { name: "advancedFilter.fbSort.leadCount", _id: "leadcount" }
];

export const adsEvalSortOptions = [
  { name: "advancedFilter.fbSort.leadCount", _id: "leadcount" },
  {
    name: "advancedFilter.fbSort.qualifiedCount",
    _id: "leadqualifiedcount"
  },
  { name: "advancedFilter.fbSort.costPerLead", _id: "cpl" },
  { name: "advancedFilter.fbSort.costPerQualified", _id: "cpql" },
  { name: "advancedFilter.fbSort.conversionRate", _id: "conversionRate" }
];

export const fbSortOrderOptions = [
  { name: "advancedFilter.sortOrder.highestFirst", _id: "high" },
  { name: "advancedFilter.sortOrder.lowestFirst", _id: "low" }
];

export const blockedZipReportOptions = [
  { name: "Daily", _id: BLOCKED_LEAD_TASK_TYPE.DAILY },
  { name: "Weekly", _id: BLOCKED_LEAD_TASK_TYPE.WEEKLY }
];

export const websiteLogsStatusOptions = [
  {
    name: "customerWebsite.RECEIVED",
    _id: CUSTOMER_SITE_CREATION_STATUS.RECEIVED
  },
  {
    name: "customerWebsite.PROCESSING",
    _id: CUSTOMER_SITE_CREATION_STATUS.PROCESSING
  },
  {
    name: "customerWebsite.COMPLETED",
    _id: CUSTOMER_SITE_CREATION_STATUS.COMPLETED
  },
  { name: "customerWebsite.FAILED", _id: CUSTOMER_SITE_CREATION_STATUS.FAILED }
];
